module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issues-category-card",
    class: {
      'has-right-side': _vm.showRightSide,
      'has-thresholds-expanded': _vm.showAlertThresholds,
      'is-row-clickable': _vm.routeProductId,
      'is-highlighted': _vm.isHighlighted
    },
    attrs: {
      "data-alert-id": _vm.alertDomId,
      "tabindex": _vm.routeProductId ? 0 : -1
    },
    on: {
      "click": _vm.openProductDetails,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.openProductDetails.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.openProductDetails.apply(null, arguments)
      }]
    }
  }, [_c('div', {
    staticClass: "issues-category-card-left"
  }, [_c('div', {
    staticClass: "issues-category-card-icon",
    class: _vm.statusClass
  }, [(_vm.statusClass === 'resolved') ? _c('i', {
    staticClass: "check icon"
  }) : (_vm.statusClass === 'ok') ? _c('i', {
    staticClass: "check icon"
  }) : (_vm.statusClass === 'suppressed') ? _c('i', {
    staticClass: "ban icon"
  }) : (_vm.statusClass === 'alert') ? _c('i', {
    staticClass: "ban icon"
  }) : (_vm.statusClass === 'rotating') ? _c('i', {
    staticClass: "sync alternate icon"
  }) : (_vm.statusClass === 'lost') ? _c('i', {
    staticClass: "time icon"
  }) : _c('i', {
    staticClass: "time icon"
  })]), _vm._v(" "), (_vm.productThumbUrl) ? [_c('img', {
    staticClass: "issues-category-card-thumb",
    attrs: {
      "src": _vm.productThumbUrl,
      "alt": "",
      "loading": "lazy",
      "decoding": "async"
    }
  })] : _c('div', {
    staticClass: "issues-category-card-thumb-placeholder",
    class: {
      'is-clickable': _vm.routeProductId
    }
  }, [_c('i', {
    staticClass: "image icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "issues-category-card-product"
  }, [_c('span', {
    staticClass: "issues-category-card-title"
  }, [_c('span', {
    staticClass: "issues-category-card-title-text",
    class: {
      'issues-category-card-title-link': _vm.routeProductId
    }
  }, [_vm._v(_vm._s(_vm.productTitle))])]), _vm._v(" "), (_vm.displayAsin) ? _c('span', {
    staticClass: "issues-category-card-asin"
  }, [_vm._v(_vm._s(_vm.feeSku ? _vm.feeSku + ' · ' + _vm.displayAsin : _vm.displayAsin))]) : _vm._e(), _vm._v(" "), _c('span', {
    class: ['issues-category-card-status', _vm.statusClass]
  }, [_vm._v(_vm._s(_vm.statusLabel))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "issues-category-card-marketplace",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.marketplaceCode) ? _c('button', {
    staticClass: "issues-marketplace-chip",
    class: {
      'is-filtered': _vm.marketplaceFilterActive
    },
    attrs: {
      "type": "button",
      "title": 'Filter alerts to ' + _vm.marketplaceLabel
    },
    on: {
      "click": _vm.onMarketplaceChipClick
    }
  }, [_c('i', {
    class: _vm.marketplaceFlagClass
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.marketplaceLabel))])]) : _c('span', {
    staticClass: "issues-marketplace-empty"
  }, [_vm._v("—")])]), _vm._v(" "), (_vm.showRightSide) ? [_c('div', {
    staticClass: "issues-category-card-right"
  }, [(_vm.changeDescriptionTableRows) ? [_c('div', {
    staticClass: "issues-change-desc-table-wrap"
  }, [_c('table', {
    staticClass: "issues-change-desc-table",
    attrs: {
      "role": "grid",
      "aria-label": "Listing changes"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.changeDescriptionTableRows), function(row, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', {
      staticClass: "issues-change-desc-field"
    }, [_vm._v(_vm._s(row.field))]), _vm._v(" "), _c('td', {
      staticClass: "issues-change-desc-cell",
      attrs: {
        "title": row.beforeTitle ? row.beforeTitle : undefined
      }
    }, [_vm._v(_vm._s(row.beforeDisplay))]), _vm._v(" "), _c('td', {
      staticClass: "issues-change-desc-cell",
      attrs: {
        "title": row.afterTitle ? row.afterTitle : undefined
      }
    }, [_vm._v(_vm._s(row.afterDisplay))])])
  }), 0)])])] : (_vm.reviewHealthInfo) ? _c('div', {
    staticClass: "issues-category-card-message issues-review-health"
  }, [_vm._l((_vm.reviewHealthInfo.rows), function(row) {
    return _c('div', {
      key: row.reason,
      staticClass: "issues-review-health-row"
    }, [_vm._v(_vm._s(row.text))])
  }), _vm._v(" "), (!_vm.reviewHealthInfo.rows.length && _vm.item.statusDetails && _vm.item.statusDetails.message) ? _c('div', {
    staticClass: "issues-review-health-row"
  }, [_vm._v(_vm._s(_vm.item.statusDetails.message))]) : _vm._e(), _vm._v(" "), (_vm.reviewHealthInfo.variationAsins.length) ? _c('div', {
    staticClass: "issues-review-health-variations"
  }, [_vm._v("Also affects " + _vm._s(_vm.reviewHealthInfo.variationAsins.length) + " variation" + _vm._s(_vm.reviewHealthInfo.variationAsins.length === 1 ? '' : 's') + ": " + _vm._s(_vm.reviewHealthInfo.variationAsins.join(', ')))]) : _vm._e()], 2) : _c('div', {
    staticClass: "issues-category-card-message"
  }, [_vm._v("\n        " + _vm._s(_vm.item.statusDetails && _vm.item.statusDetails.message ? _vm.item.statusDetails.message : '') + "\n        "), (_vm.feeReason) ? _c('div', {
    staticClass: "issues-fee-reason",
    class: 'is-' + _vm.feeReason.tone
  }, [(_vm.feeReason.lead) ? _c('span', {
    staticClass: "issues-fee-reason-lead"
  }, [_vm._v(_vm._s(_vm.feeReason.lead))]) : _vm._e(), _vm._v(_vm._s(_vm.feeReason.rest) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "issues-category-card-actions",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.sellerCentralUrl) ? _c('a', {
    staticClass: "issues-category-card-btn issues-category-card-btn-orange",
    attrs: {
      "href": _vm.sellerCentralUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n          View in Seller Central\n        ")]) : _vm._e(), _vm._v(" "), (_vm.viewUrl) ? _c('a', {
    staticClass: "issues-category-card-btn",
    class: _vm.sellerCentralUrl ? 'issues-category-card-btn-blue' : 'issues-category-card-btn-orange',
    attrs: {
      "href": _vm.viewUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.viewUrlLabel) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.feeClaimDownloadUrl) ? _c('a', {
    staticClass: "issues-category-card-btn issues-category-card-btn-green",
    attrs: {
      "href": _vm.feeClaimDownloadUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n          Download orders\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showMarkResolvedButton) ? _c('button', {
    staticClass: "issues-category-card-btn issues-category-card-btn-resolve",
    attrs: {
      "type": "button",
      "disabled": _vm.markResolveBusy
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('mark-resolved', _vm.item)
      }
    }
  }, [_vm._v("\n          Mark as resolved\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showAlertThresholdsButton) ? _c('button', {
    staticClass: "issues-category-card-btn issues-category-card-btn-settings",
    class: {
      active: _vm.showAlertThresholds
    },
    attrs: {
      "title": "Alert thresholds"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleAlertThresholds.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "cog icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.item.muted) ? _c('a', {
    staticClass: "issues-category-card-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mute(-1)
      }
    }
  }, [_vm._v("Un-mute")]) : _vm._e()])], 2), _vm._v(" "), (_vm.item.date) ? _c('div', {
    staticClass: "issues-category-card-date"
  }, [_vm._v("\n      " + _vm._s(_vm.formatDate(_vm.item.date)) + "\n    ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showAlertThresholds && _vm.showAlertThresholdsButton) ? _c('div', {
    staticClass: "issues-category-card-thresholds",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.wdtype === 'inventory') ? _c('AlertThresholdsInline', {
    attrs: {
      "item": _vm.item,
      "product-id": _vm.routeProductId,
      "seller-account-id": _vm.sellerAccountIdForThresholds,
      "product-title": _vm.productTitle,
      "marketplace": _vm.item.marketplace || '',
      "stock-thresholds-api-base": _vm.stockAlertThresholdsApiBaseUrl,
      "api-base-url": _vm.apiBaseUrl
    },
    on: {
      "saved": _vm.onThresholdsSaved,
      "cancel": function($event) {
        _vm.showAlertThresholds = false
      }
    }
  }) : (_vm.wdtype === 'fbmInventory') ? _c('fbm-alert-thresholds-inline', {
    attrs: {
      "item": _vm.item,
      "product-id": _vm.routeProductId,
      "seller-account-id": _vm.sellerAccountIdForThresholds,
      "product-title": _vm.productTitle,
      "stock-thresholds-api-base": _vm.stockAlertThresholdsApiBaseUrl,
      "api-base-url": _vm.apiBaseUrl
    },
    on: {
      "saved": _vm.onThresholdsSaved,
      "cancel": function($event) {
        _vm.showAlertThresholds = false
      }
    }
  }) : (_vm.wdtype === 'salesDrop') ? _c('sales-volume-thresholds-inline', {
    attrs: {
      "item": _vm.item,
      "product-id": _vm.routeProductId,
      "seller-account-id": _vm.sellerAccountIdForThresholds,
      "product-title": _vm.productTitle,
      "marketplace": _vm.item.marketplace || '',
      "sales-volume-thresholds-api-base": _vm.salesVolumeThresholdsApiBaseUrl
    },
    on: {
      "saved": _vm.onThresholdsSaved,
      "cancel": function($event) {
        _vm.showAlertThresholds = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Field")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Before")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("After")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17cb5484!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/issues/IssuesCategoryCard.vue
// module id = 730
// module chunks = 2